import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";
import CommonSelect from "../../common/components/CommonSelect";
import { PreferredDurations } from "../../common/const";

const TimeLine = ({
    formData,
    handleInputChange,
    errors
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            padding="0px"
            background="#EAF9CD"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>Timeline & Commitment</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add your Skill & Experience Assessment</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={4}>
                        <CommonSelect
                            label="Preferred Duration"
                            name="preferredDuration"
                            value={formData.preferredDuration}
                            onChange={handleInputChange}
                            placeholder="Select Duration"
                            options={PreferredDurations}
                            error={errors.preferredDuration}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="Weekly Time (hours)"
                            type="email"
                            name="weeklyTime"
                            value={formData.weeklyTime}
                            onChange={handleInputChange}
                            placeholder="e.g. 5-10"
                            error={errors.weeklyTime}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonFormField
                            label="Taget Completion Date"
                            type="date"
                            name="targetDate"
                            value={formData.targetDate}
                            onChange={handleInputChange}
                            placeholder="mm/dd/yyyy"
                            error={errors.targetDate}
                        />
                    </Grid>
                </Grid>
            }
        />
    )
}

export default TimeLine;